import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

/**
 * Pipe to mark HTML as sanitized (trusted). ***USE CAREFULLY AND WHERE APPPLICABLE ONLY!***
 */
@Pipe({
  name: 'trustedHtml',
  pure: true
})
export class TrustedHtmlPipe implements PipeTransform {

  /**
   * Constructor
   * @param sanitizer DomSanitizer
   */
  constructor(private sanitizer: DomSanitizer) { }

  /**
   * Bypasses Angular security and marks the HTML as trusted. ***MAKE SURE TO SANITIZE THIS IN THE API IF THE USER CAN INFLUENCE IT***
   * @param html
   */
  transform(html) {
    /*
     * Instead of just bypassing all security, we sanitize the HTML content against XSS vulnerabilities. Therefore, the SC Vulnerability can be set to safe
     * Just trusting in Kendo isn't enough: It's still possible to inject XSS vulnerabilities by senting a POST to the API
     */
    return this.sanitizer.bypassSecurityTrustHtml(DOMPurify.sanitize(html));
  }
}
